import * as React from 'react';
import { t } from '../../i18n';
import LoginContainer from '../../containers/Auth/Login';

const LoginPage = () => {
  return (
    <>
      <div className="mb-30">
        <h1 className="mb-10">{t('login.title')}</h1>
        <p>{t('login.description')}</p>
      </div>
      <LoginContainer />
    </>
  );
};

export default LoginPage;
